import { render, staticRenderFns } from "./SysMessageList.vue?vue&type=template&id=eb1960fc&scoped=true"
import script from "./SysMessageList.vue?vue&type=script&lang=js"
export * from "./SysMessageList.vue?vue&type=script&lang=js"
import style0 from "./SysMessageList.vue?vue&type=style&index=0&id=eb1960fc&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1960fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb1960fc')) {
      api.createRecord('eb1960fc', component.options)
    } else {
      api.reload('eb1960fc', component.options)
    }
    module.hot.accept("./SysMessageList.vue?vue&type=template&id=eb1960fc&scoped=true", function () {
      api.rerender('eb1960fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/message/SysMessageList.vue"
export default component.exports